import {
  DELETE_EDM_USER,
  SET_LOADING,
  UPDATE_EDM_USERS,
} from './actions/edmUsers'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const EdmUsers = RepositoryFactory.get('edmUsers')

export default {
  namespaced: true,
  state: {
    users: [],
    loading: false,
  },
  getters: {
    getUsers: state => state.users,
    getLoading: state => state.loading,
  },
  actions: {
    fetchUsers({ commit }, settings) {
      commit(SET_LOADING, true)
      EdmUsers.getList(settings)
        .then(res => commit(UPDATE_EDM_USERS, res.data))
        .catch(() => commit(SET_LOADING, false))
    },
  },
  mutations: {
    [UPDATE_EDM_USERS]: (state, items) => {
      state.users = items
      state.loading = false
    },
    [DELETE_EDM_USER]: (state, { id }) => {
      state.users.splice(
        state.users.findIndex(i => i.id === id),
        1,
      )
    },
    [SET_LOADING]: (state, flag) => {
      state.loading = Boolean(flag)
    },
  },
}
